import { NoteBlock } from "../block";

export interface LogStreamBlock extends NoteBlock {
  type: "omega/query-omega/page/block/log-stream/LogStreamBlock";
  "log-stream-id": string;
}

export const isLogStreamBlock = (block: NoteBlock): block is LogStreamBlock => {
  return (block as LogStreamBlock)["log-stream-id"] !== undefined;
};
